import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { selectCartGroupOrder } from 'bento-ordering/cart/selectors/index';
import { GROUP_ORDER_JOIN } from 'bento-ordering/group_ordering/constants/paths';
import { isRoute } from 'bento-ordering/group_ordering/utils';
import { goToMenu } from 'bento-ordering/cart/actions/orderSettings';

const useRedirectDinerToMenuPage = () => {
  const groupOrder = useSelector(selectCartGroupOrder);
  const dispatch = useDispatch();

  const { current_diner: currentDiner = undefined } = groupOrder;
  const isGroupOrderJoinPath = isRoute(GROUP_ORDER_JOIN);

  useEffect(() => {
    if (isGroupOrderJoinPath && !isEmpty(currentDiner)) {
      dispatch(goToMenu());
    }
  }, [dispatch, isGroupOrderJoinPath, currentDiner]);

  return null;
};

export default useRedirectDinerToMenuPage;
